import * as angular from "angular";
import * as _ from "lodash";

declare let gtag: any;

export class AnalyticsService {

  constructor() {
  }

  private userId: string;
  private dimension1: string; // Site ID
  private dimension2: string; // Site Name
  private dimension3: string; // Organization ID
  private dimension4: string; // Organization Name
  private dimension5: boolean; // Is Super Admin
  // private dimension6: string[]; // BranchIds
  private dimension7: string[]; // GroupIds
  private dimension8: string[]; // Roles Group Ids


  // ******************************
  // External methods
  // ******************************

  initWelcome(user, permissions) {

    // GTAG
    this.userId = user.userHash;
    this.dimension1 = null;
    this.dimension2 = null;
    this.dimension3 = null;
    this.dimension4 = null;
    this.dimension5 = this.isSuperAdmin(permissions);

    gtag('set', 'user_properties', {
        'userId': this.userId,
        'dimension1': this.dimension1,
        'dimension2': this.dimension2,
        'dimension3': this.dimension3,
        'dimension4': this.dimension4,
        'dimension5': this.dimension5
    })
  }

  initOrganization(user, organization, permissions) {

    // GTAG
    this.userId = user.userHash;
    this.dimension1 = null;
    this.dimension2 = null;
    this.dimension3 = organization.id;
    this.dimension4 = organization.name;
    this.dimension5 = this.isSuperAdmin(permissions);

    gtag('set', 'user_properties', {
      'userId': this.userId,
      'dimension1': this.dimension1,
      'dimension2': this.dimension2,
      'dimension3': this.dimension3,
      'dimension4': this.dimension4,
      'dimension5': this.dimension5
    })
  }

  initSite(user, site, permissions, siteInfo) {

    // GTAG
    this.userId = user.userHash;
    this.dimension1 = site.id;
    this.dimension2 = site.name;
    this.dimension3 = site.parent.id;
    this.dimension4 = site.parent.name;
    this.dimension5 = this.isSuperAdmin(permissions);
    this.dimension7 = siteInfo.groups;
    this.dimension8 = siteInfo.userRolesGroupIds;

    gtag('set', 'user_properties', {
      'userId': this.userId,
      'dimension1': this.dimension1,
      'dimension2': this.dimension2,
      'dimension3': this.dimension3,
      'dimension4': this.dimension4,
      'dimension5': this.dimension5,
      'dimension7': this.dimension7,
      'dimension8': this.dimension8
    })
  }

  trackEvent(category, action, label?, fromUrl?) {

    // GTAG
    gtag('event', action, {
      category: category,
      label: label,
      fromPage: fromUrl
    });
  }

  trackException(rejection) {

    // GTAG
    gtag('event', 'exception', {
      status: rejection.status,
      url: rejection.config.url,
      method: rejection.config.method,
      code: rejection.data?.code,
      more_info: rejection.data?.more_info
    });
  }

  // ******************************
  // Internal methods
  // ******************************

  private isSuperAdmin(permissions) {
    return _.some(permissions, function (p) {
      return p && p.id === 'super.owner'
    });
  }
}

angular
  .module('bringoz.admin.commons')
  .service('analyticsService', AnalyticsService);
